<template>
  <div
    class="p-contentplans-writing-user-fieldset"
    :class="{ 'is-blink': isBlink }"
  >
    <div class="p-contentplans-writing-user-fieldset__header">
      <h4 class="p-contentplans-writing__title--sub">
        どのようなユーザーに、読後にどう思ってもらいたいか
      </h4>
      <p class="p-contentplans-writing__note">最大{{ maxLength }}文字</p>
    </div>
    <p class="p-contentplans-writing__note">
      例:
      SEO対策について興味のあるユーザーに、メリット・デメリットや対策方法を知ってほしい。
    </p>
    <div v-if="isEditMode" class="c-alertPos">
      <Textarea
        :value="value"
        autosize
        :rows="1"
        :class="{ alert: error }"
        ref="input"
        @input="input"
      />
      <Alert v-if="error">{{ error }}</Alert>
    </div>
    <p v-else>{{ value }}</p>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Textarea from '@/components/Textarea';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    error: {
      type: String,
      required: false
    },
    maxLength: {
      type: Number,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    isEditMode: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Alert,
    Textarea
  },
  data() {
    return {
      isBlink: false
    };
  },
  methods: {
    focusInput() {
      this.$refs.input.$el.focus();
      this.$nextTick(() => {
        this.isBlink = true;
        setTimeout(() => {
          this.isBlink = false;
        }, 3000);
      });
    },
    input(value) {
      this.$emit('input', value);
    }
  }
};
</script>
